import React, { createContext, useContext } from 'react'

function getBreakpoint(width) {
  if (width >= 1440) return 'wide'
  if (width >= 1024) return 'desktop'
  if (width >= 640) return 'tablet'
  return 'mobile'
}

function useResponsive() {
  const [width, setWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1024)

  React.useEffect(() => {
    if (typeof window === 'undefined') return undefined
    let raf = null
    const onResize = () => {
      if (raf) cancelAnimationFrame(raf)
      raf = requestAnimationFrame(() => setWidth(window.innerWidth))
    }
    const mqls = [
      window.matchMedia('(min-width: 640px)'),
      window.matchMedia('(min-width: 1024px)'),
      window.matchMedia('(min-width: 1440px)'),
    ]
    mqls.forEach(m => m.addEventListener?.('change', onResize))
    window.addEventListener('resize', onResize)
    return () => {
      mqls.forEach(m => m.removeEventListener?.('change', onResize))
      window.removeEventListener('resize', onResize)
      if (raf) cancelAnimationFrame(raf)
    }
  }, [])

  const breakpoint = React.useMemo(() => getBreakpoint(width), [width])
  const isMobile = breakpoint === 'mobile'
  const isTablet = breakpoint === 'tablet'
  const isDesktop = breakpoint === 'desktop'
  const isWide = breakpoint === 'wide'

  return { width, breakpoint, isMobile, isTablet, isDesktop, isWide }
}

const ResponsiveContext = createContext({
  width: 1024,
  breakpoint: 'desktop',
  isMobile: false,
  isTablet: false,
  isDesktop: true,
  isWide: false,
})

export function ResponsiveProvider({ children }) {
  const value = useResponsive()
  return (
    <ResponsiveContext.Provider value={value}>
      {children}
    </ResponsiveContext.Provider>
  )
}

export function useResponsiveContext() {
  return useContext(ResponsiveContext)
}
